import React, { FC, useState } from 'react';
import { Cue } from '../../helpers/events/types';
import TrimWebEventModal from '../TrimWebEventModal';
import PropTypes from 'prop-types';

interface TrimWebEventButtonProps {
  cues?: Cue[];
  webPlayer: any;
  webEventId?: string;
  webEventProfileId?: string;
  customerId?: string;
  webEventName?: string;
  isWebEventLive?: boolean;
}

const TrimWebEventButton: FC<TrimWebEventButtonProps> = ({
  cues,
  webPlayer,
  webEventId,
  customerId,
  webEventProfileId,
  webEventName,
  isWebEventLive
}): JSX.Element => {
  const [isOpenTrimWebEventModal, setIsOpenTrimWebEventModal] = useState(false);

  const handleTrimWebEventBtnClick = (): void => {
    if (webPlayer) {
      webPlayer.getVideo().pause();
    }
    setIsOpenTrimWebEventModal(true);
  };

  return (
    <>
      <button className="btn btn-primary" onClick={(): void => handleTrimWebEventBtnClick()}>
        <i className="fa fa-cut" aria-hidden="true" style={{ marginRight: 7 }}></i>
        Trim Event
      </button>
      {isOpenTrimWebEventModal && (
        <TrimWebEventModal
          cues={cues}
          handleCloseModal={(): void => setIsOpenTrimWebEventModal(false)}
          webEventId={webEventId}
          customerId={customerId}
          webEventProfileId={webEventProfileId}
          webEventName={webEventName}
          isWebEventLive={isWebEventLive}
        />
      )}
    </>
  );
};

TrimWebEventButton.displayName = 'TrimWebEventButton';

TrimWebEventButton.propTypes = {
  cues: PropTypes.array,
  webPlayer: PropTypes.any,
  webEventId: PropTypes.string,
  customerId: PropTypes.string,
  webEventProfileId: PropTypes.string,
  webEventName: PropTypes.string
};

export default TrimWebEventButton;
